import type { HubTagTemplate } from '../../../dorian-shared/types/branch/HubTagTemplate';

const NAME_PATTERN = /^[a-zA-Z0-9_\-.$&]*$/;
export const NAME_MIN = 2;
export const NAME_MAX = 254;
export const TEXT_MAX = 15;

export function getNameError(name: string, allNames: string[], excludeIndex: number): string {
  if (!name.trim()) return 'Required';
  if (name.length < NAME_MIN) return `Must be ${NAME_MIN} characters or more`;
  if (name.length > NAME_MAX) return `Must be ${NAME_MAX} characters or less`;
  if (!NAME_PATTERN.test(name)) return 'Only letters, numbers, and _-.$& allowed';
  if (allNames.some((n, i) => i !== excludeIndex && n === name)) return 'Name must be unique';
  return '';
}

export function getContentError(text: string | null, iconId: number | null): string {
  if (!text?.trim() && iconId == null) return 'Text or icon required';
  return '';
}

export function hasTemplateError(template: HubTagTemplate, allNames: string[], index: number): boolean {
  return !!getNameError(template.name, allNames, index)
    || !!getContentError(template.text, template.iconId);
}

export function validateTemplates(templates: HubTagTemplate[]): string | null {
  const names: string[] = [];
  for (const t of templates) {
    if (!t.name.trim() || t.name.length < NAME_MIN) {
      return 'All tag templates must have a name (min 2 characters)';
    }
    if (!NAME_PATTERN.test(t.name)) {
      return `Tag "${t.name}": only letters, numbers, and _-.$& allowed`;
    }
    if (names.includes(t.name)) {
      return `Duplicate tag template name: "${t.name}"`;
    }
    names.push(t.name);
    if (!t.text?.trim() && t.iconId == null) {
      return `Tag "${t.name}": display text or icon is required`;
    }
  }
  return null;
}
